// ─── Tracking Layer v2 — Bundle Entry ───
// Ponto de entrada bundlado por esbuild (ver task `typescriptTrackingBundle` no
// gulpfile). Reúne core + adapters num único arquivo (`tracking-bundle.js`) e
// inicializa tudo numa sequência síncrona e determinística:
//
//   create service -> registra adapters -> drena buffer do stub inline
//
// Carregar como UM script no lugar dos antigos tracking-core.js + tracking-adapters.js
// elimina a corrida de ordem de carregamento entre os dois.

import { bootstrapCore } from "./tracking-core";
import { GTMAdapter, RudderAdapter } from "./tracking-adapters";

const adapters: TrackingAdapter[] = [GTMAdapter];

// Rudder é condicional: só registra se o SDK já estiver presente. Se carregar
// depois, registrar via window.__tracking.registerAdapter(RudderAdapter).
if ((window as any).rudderanalytics) {
  adapters.push(RudderAdapter);
}

bootstrapCore(adapters);
